module.exports = __webpack_public_path__ + "img/Sumpfkühe.cd32f5eb.svg";